<template>
  <van-popup
      v-model="showPopup"
      round
      position="bottom"
      closeable
      close-icon-position="top-right"
      :close-on-click-overlay="false"
      @close="cancel"
  >
    <div class="modal-container">
      <div class="modal-title">暂停营业申请</div>
      <van-form>
        <div class="form-group bgn">
          <label class="form-label">营业状态</label>
          <div class="reason-tags">
            <div class="reason-tag" :class="businessStatus===item.id?'selected':''" v-for="(item,index) in stateTypeOptions" :key="index" @click="getState(item,index)">{{ item.text }}</div>
          </div>
        </div>
        <div class="form-group bgn" v-show="businessStatus===2">
          <label class="form-label">停业原因</label>
          <div class="reason-tags">
            <div class="reason-tag" :class="form.closureReason===item.text?'selected':''" v-for="(item,index) in deviceTypeOptions" :key="index" @click="getReason(item,index)">{{ item.text }}</div>
          </div>
        </div>
        <!--        营业状态-->
<!--        <van-field-->
<!--            v-model="form.businessType"-->
<!--            name="businessType"-->
<!--            label="营业状态"-->
<!--            placeholder="请选择营业状态"-->
<!--            :rules="[{ required: true, message: '请选择营业状态' }]"-->
<!--            readonly-->
<!--            @click="showStateTypePicker = true"-->
<!--        >-->
<!--          <template #right-icon>-->
<!--            <van-icon name="arrow-down" />-->
<!--          </template>-->
<!--        </van-field>-->
<!--        <van-popup-->
<!--            v-model="showStateTypePicker"-->
<!--            round-->
<!--            position="bottom"-->
<!--        >-->
<!--          <van-picker-->
<!--              show-toolbar-->
<!--              title="选择营业状态"-->
<!--              :columns="stateTypeOptions"-->
<!--              values="text"-->
<!--              @confirm="onStateTypeConfirm"-->
<!--              @cancel="showStateTypePicker = false"-->
<!--          />-->
<!--        </van-popup>-->
<!--        <div class="modal-card-info">-->
<!--          <div class="modal-info-label">营业状态</div>-->
<!--          <div class="modal-info-value">-->
<!--            <van-switch v-model="form.checked" />-->
<!--          </div>-->
<!--        </div>-->
<!--        <van-field-->
<!--            v-model="form.businessType"-->
<!--            name="businessType"-->
<!--            label="停业原因"-->
<!--            placeholder="请选择停业原因"-->
<!--            :rules="[{ required: true, message: '请选择停业原因' }]"-->
<!--            readonly-->
<!--            disabled-->
<!--            @click="showDeviceTypePicker = true"-->
<!--        >-->
<!--          <template #right-icon>-->
<!--            <van-icon name="arrow-down" />-->
<!--          </template>-->
<!--        </van-field>-->
<!--        <van-popup-->
<!--            v-model="showDeviceTypePicker"-->
<!--            round-->
<!--            position="bottom"-->
<!--        >-->
<!--          <van-picker-->
<!--              show-toolbar-->
<!--              title="选择停业原因"-->
<!--              :columns="deviceTypeOptions"-->
<!--              values="text"-->
<!--              @confirm="onDeviceTypeConfirm"-->
<!--              @cancel="showDeviceTypePicker = false"-->
<!--          />-->
<!--        </van-popup>-->
<!--        &lt;!&ndash;        所在地区选择&ndash;&gt;-->
<!--        <van-field v-model="form.city" name="city" label="所在地区" placeholder="请选择省市区" disabled :rules="[{ required: true, message: '请选择省市区' }]" @click="showFaultTypePicker = true" >-->
<!--          <template #right-icon>-->
<!--            <van-icon name="arrow-down" />-->
<!--          </template>-->
<!--        </van-field>-->
<!--        <van-popup v-model="showFaultTypePicker" position="bottom">-->
<!--          <van-area :area-list="areaList" @confirm="onFaultTypeConfirm" @cancel="showFaultTypePicker = false" />-->
<!--        </van-popup>-->
<!--        &lt;!&ndash;     详细地址   &ndash;&gt;-->
<!--        <van-field-->
<!--            v-model="form.address"-->
<!--            name="address"-->
<!--            label="详细地址"-->
<!--            type="textarea"-->
<!--            placeholder="请输入详细地址"-->
<!--            disabled-->
<!--            :rules="[{ required: true, message: '请输入详细地址' }]"-->
<!--            rows="3"-->
<!--            autosize-->
<!--        />-->
        <div class="form-buttons">
          <van-button round block plain type="default" native-type="button" @click="cancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" native-type="submit" @click="onSubmit">保存</van-button>
        </div>
      </van-form>
    </div>
  </van-popup>
</template>
<script>
export default {
  name: 'updateSiteInfo',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    siteItem:{
      type:Object,
      default: {}
    }
  },
  data() {
    return {
      showPopup: this.value,
      // showStateTypePicker: false,
      // showDeviceTypePicker: false,
      // showFaultTypePicker: false,
      // areaList: {
      //   "province_list": {
      //     "540000": "西藏自治区",
      //   },
      //   "city_list": {
      //     "540100": "拉萨市",
      //     "540200": "日喀则市",
      //     "540300": "昌都市",
      //     "540400": "林芝市",
      //     "540500": "山南市",
      //     "540600": "那曲市",
      //     "542500": "阿里地区",
      //   },
      //   "county_list": {
      //     "540102": "城关区",
      //     "540103": "堆龙德庆区",
      //     "540104": "达孜区",
      //     "540121": "林周县",
      //     "540122": "当雄县",
      //     "540123": "尼木县",
      //     "540124": "曲水县",
      //     "540127": "墨竹工卡县",
      //
      //     "540202": "桑珠孜区",
      //     "540221": "南木林县",
      //     "540222": "江孜县",
      //     "540223": "定日县",
      //     "540224": "萨迦县",
      //     "540225": "拉孜县",
      //     "540226": "昂仁县",
      //     "540227": "谢通门县",
      //     "540228": "白朗县",
      //     "540229": "仁布县",
      //     "540230": "康马县",
      //     "540231": "定结县",
      //     "540232": "仲巴县",
      //     "540233": "亚东县",
      //     "540234": "吉隆县",
      //     "540235": "聂拉木县",
      //     "540236": "萨嘎县",
      //     "540237": "岗巴县",
      //     "540302": "卡若区",
      //     "540321": "江达县",
      //     "540322": "贡觉县",
      //     "540323": "类乌齐县",
      //     "540324": "丁青县",
      //     "540325": "察雅县",
      //     "540326": "八宿县",
      //     "540327": "左贡县",
      //     "540328": "芒康县",
      //     "540329": "洛隆县",
      //     "540330": "边坝县",
      //     "540402": "巴宜区",
      //     "540421": "工布江达县",
      //     "540422": "米林县",
      //     "540423": "墨脱县",
      //     "540424": "波密县",
      //     "540425": "察隅县",
      //     "540426": "朗县",
      //     "540502": "乃东区",
      //     "540521": "扎囊县",
      //     "540522": "贡嘎县",
      //     "540523": "桑日县",
      //     "540524": "琼结县",
      //     "540525": "曲松县",
      //     "540526": "措美县",
      //     "540527": "洛扎县",
      //     "540528": "加查县",
      //     "540529": "隆子县",
      //     "540530": "错那县",
      //     "540602": "色尼区",
      //     "540621": "嘉黎县",
      //     "540622": "比如县",
      //     "540623": "聂荣县",
      //     "540624": "安多县",
      //     "540625": "申扎县",
      //     "540626": "索县",
      //     "540627": "班戈县",
      //     "540628": "巴青县",
      //     "540629": "尼玛县",
      //     "540630": "双湖县",
      //     "542521": "普兰县",
      //     "542522": "札达县",
      //     "542523": "噶尔县",
      //     "542524": "日土县",
      //     "542525": "革吉县",
      //     "542526": "改则县",
      //     "542527": "措勤县",
      //   }
      // },
      businessStatus:this.siteItem.businessStatus,
      form:{},
      stateTypeOptions: [
        {id: 1, text: '正常营业'},
        {id: 2, text: '暂停营业'},
      ],
      deviceTypeOptions: [
        {id: '1', text: '店铺装修'},
        {id: '2', text: '人员休假'},
        {id: '3', text: '网点停电'},
        {id: '4', text: '设备维修'},
        {id: '5', text: '网点迁移'},
      ],
    }
  },
  watch: {
    value(val) {
      this.showPopup = val
    },
    showPopup(val) {
      this.$emit('input', val)
    },
    siteItem: {
      immediate: true, // 立即执行一次
      handler(newVal) {
        if (newVal) {
          // 在这里处理数据
          this.form = newVal;
          this.businessStatus = newVal.businessStatus;
        }
      }
    }
  },
  created() {

  },
  methods: {
    getState(item){
      this.businessStatus = item.id;
      this.form.closureReason = '';
    },
    getReason(item){
      console.log(item)
      this.form.closureReason = item.text;
      console.log(this.form.closureReason)
    },
    onSubmit() {
      this.form.businessStatus = this.businessStatus;
      if(this.form.businessStatus===2){
        if(this.form.closureReason === ''){
          this.$toast('请选择停业原因！');
          return false;
        }
      }
      this.$emit('submit', { ...this.form });
    },
    cancel() {
      this.form = this.siteItem;
      this.showPopup = false;
    },
  }
}
</script>

<style lang="scss" scoped>
.time-pick-box{
  background: #f9f9f9;
  border-radius: 10px;
  padding: 20px 10px;
  box-sizing: border-box;
  margin-bottom: 20px;
  .van-field__control{
    margin-left: 22px;
    padding-left: 10px;
  }
}
</style>
